import { useCallback, useEffect, useRef, useState } from "react";

import { avisar, buscarComanda, capturarToken, tokenDaConversa } from "./linkConversa";

// Cardápio: avisa o Recuperador quando o cliente abre pelo link da conversa e
// quando mexe no carrinho (resumo: nome, quantidade e total). Sem token, não faz nada.
//
// Quem abre o link com um pedido anotado pela CLEO na conversa recebe os itens
// em `comandaDaConversa` (formato do pedido): o cardápio põe no carrinho e chama
// `esquecerComanda`.
export function useLinkConversa(cart) {
  const ultimo = useRef("");
  const [comandaDaConversa, setComandaDaConversa] = useState(null);

  useEffect(() => {
    const token = capturarToken();
    if (!token) return undefined;
    avisar("abriu");
    let vivo = true;
    buscarComanda(token).then((itens) => {
      if (vivo && itens.length) setComandaDaConversa(itens);
    });
    return () => { vivo = false; };
  }, []);

  useEffect(() => {
    if (!tokenDaConversa()) return undefined;
    const itens = (cart || []).map((i) => ({ nome: String(i.name || i.nome || "").slice(0, 60), qtd: Number(i.quantity || 1) }));
    const total = (cart || []).reduce((s, i) => s + Number(i.final_price || i.sale_price || 0) * Number(i.quantity || 1), 0);
    const assinatura = JSON.stringify(itens);
    if (assinatura === ultimo.current) return undefined;
    const timer = setTimeout(() => {
      ultimo.current = assinatura;
      avisar("carrinho", { itens, total: Math.round(total * 100) / 100 });
    }, 2500);
    return () => clearTimeout(timer);
  }, [cart]);

  const esquecerComanda = useCallback(() => setComandaDaConversa(null), []);
  return { comandaDaConversa, esquecerComanda };
}
